import React from 'react';
import FormattedCurrency from '../../../../components/formatted-currency';

import { RateLabel } from '../../shared-field-labels/shared-field-labels';
import { useFulfillmentDisplayContext } from '../display-context';
import ReadonlyField from './readonly-field';

export const Rate = () => {
  const { rate } = useFulfillmentDisplayContext();
  const { code, value } = rate || {};
  return (
    <ReadonlyField label={RateLabel}>
      <FormattedCurrency code={code} value={value} />
    </ReadonlyField>
  );
};
